import React, {useEffect, useMemo, useState} from 'react';

interface ApplicationNavPanelMenuProps {
   menuContent: string;
   hideMenu: () => void;
}

const eventHandlers = {
   click: () => {}
};

const clickFn = () => {
   eventHandlers.click();
};

const updateMenuButtons = () => {
   const menuClass = ".uf-application-nav-panel-menu-inner";
   ["a", ".x-button"].map(selector => `${menuClass} ${selector}`).forEach(selector => {
      document.querySelectorAll(selector).forEach(function(node) {
         node.removeEventListener('click', clickFn);
         node.addEventListener('click', clickFn);
      });
   });
};

export const ApplicationNavPanelMenu = (props: ApplicationNavPanelMenuProps) => {
   const { hideMenu, menuContent } = props;

   useEffect(() => {
      updateMenuButtons();
      eventHandlers.click = () => {
         hideMenu();
      };
   }, [hideMenu]);

   useEffect(() => {
      updateMenuButtons();
   }, [menuContent]);

   return (
      <div
         className={'uf-application-nav-panel-menu'}
      >
         <div
            className={'uf-application-nav-panel-menu-inner'}
            dangerouslySetInnerHTML={{ __html: props.menuContent }}
         />
      </div>
   );
};
